export {}

// DATE EXTENSIONS
// ================


declare global {
    interface DateConstructor {
        isLeapYear: (year:number) => boolean;
        getDaysInMonth: (year:number, month:number) => number;
    }
    interface Date {
        addMinutes: (minutes:number) => Date;
        addHours: (hours:number) => Date;
        addDays: (days:number) => Date;
        isLeapYearByYear: (year) => boolean;
        isLeapYear: () => boolean;
        getDaysInMonth: () => number;
        addMonths: (value: number) => Date;
        addYears: (year:number) => Date;
        getFullMonth: () => string;
        toIsoString: () => string;
    }
}
Date.prototype.addMinutes = function(m) {
    let dat = new Date(this.valueOf());
    dat.setTime(dat.getTime() + (m*60*1000));
    return dat;
};
Date.prototype.addHours = function(h) {
    let dat = new Date(this.valueOf());
    dat.setTime(dat.getTime() + (h*60*60*1000));
    return dat;
};
Date.prototype.addDays = function (days) {
    let dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
};
Date.isLeapYear = function (year) {
    return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
};
Date.getDaysInMonth = function (year, month) {
    return [31, (Date.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
};
Date.prototype.isLeapYear = function () {
    return Date.isLeapYear(this.getFullYear());
};

Date.prototype.getDaysInMonth = function () {
    return Date.getDaysInMonth(this.getFullYear(), this.getMonth());
};
Date.prototype.addMonths = function (value) {
    let n = this.getDate();
    this.setDate(1);
    this.setMonth(this.getMonth() + value);
    this.setDate(Math.min(n, this.getDaysInMonth()));
    return this;
};
Date.prototype.addYears = function (years) {
    let dat = new Date(this.valueOf());
    dat.setFullYear(dat.getFullYear() + years);
    return dat;
};
Date.prototype.getFullMonth = function(){
    let month = this.getMonth()+1;
    if(month < 10) return "0"+month;
    return month.toString();
};
Date.prototype.toIsoString = function () {
    let month = '' + (this.getMonth() + 1),
        day = '' + this.getDate(),
        year = '' + this.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
};